/**
 * @author Harish.R <harish.r@314ecorp.com>
 * @description Integration config
 */
import _ from 'lodash';
import { getRealmName } from 'utils/common';
import Environment from 'utils/environment';
import { MARKER_IO_INTEGRATION_PROJECT_ID, POST_HOG_INTEGRATION_API_KEY, POSTHOG_UI_HOST } from './url';
import { POSTHOG_EVENTS_TO_BLOCK } from 'utils/configUtils';

const { clientURL, authURL, accountsURL, posthogURL } = Environment.getHostNames('integration');

/**
 * Integration config
 */
const config: EnvConfig = {
	keycloak: {
		config: {
			realm: getRealmName(),
			url: authURL,
			clientId: 'veritable',
		},
		initOptions: {
			onLoad: 'login-required',
			checkLoginIframe: false,
			token: '',
			enableLogging: true,
		},
		loginOptions: {
			loginHint: Environment.getLoginHint(),
		},
	},
	markerIO: {
		disabled: Environment.isLocalhost(),
		project: MARKER_IO_INTEGRATION_PROJECT_ID,
	},
	postHog: {
		apiKey: POST_HOG_INTEGRATION_API_KEY,
		config: {
			api_host: posthogURL,
			ui_host: POSTHOG_UI_HOST,
			autocapture: false,
			capture_pageview: false,
			capture_exceptions: {
				capture_console_errors: true,
				capture_unhandled_rejections: true,
				capture_unhandled_errors: true,
			},
			opt_out_capturing_by_default: Environment.isLocalhost(),
			before_send: (cr) => (!_.includes(POSTHOG_EVENTS_TO_BLOCK, cr?.event) ? cr : null),
		},
	},
	client: {
		baseURL: clientURL,
	},
	accountsClient: {
		baseURL: accountsURL,
	},
};

export default config;
